"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectSheet = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _utils = require("@material-ui/utils");
var _theme = _interopRequireDefault(require("./theme"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: // 

import { type ComponentType } from 'react';*/
/*:: import type { CSS, Creator } from './ThemeTypes';*/
// Alias `injectSheet` for backwards compatibility.
var injectSheet = exports.injectSheet = function injectSheet(stylesOrCreator /*: CSS | Creator*/) {
  var options /*: {}*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (WrappedComponent /*: ComponentType<*>*/) {
    // Convention: Wrap the Display Name for Easy Debugging
    // https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
    var WithInjectSheet = /*#__PURE__*/function (_React$Component) {
      function WithInjectSheet() {
        (0, _classCallCheck2.default)(this, WithInjectSheet);
        return _callSuper(this, WithInjectSheet, arguments);
      }
      (0, _inherits2.default)(WithInjectSheet, _React$Component);
      return (0, _createClass2.default)(WithInjectSheet, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
        }
      }]);
    }(_react.default.Component);
    WithInjectSheet.displayName = "WithInjectSheet(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
    return (0, _styles.withStyles)(stylesOrCreator, _objectSpread({
      defaultTheme: _theme.default,
      withTheme: true
    }, options))(WithInjectSheet);
  };
};
var _default = exports.default = injectSheet;
//# sourceMappingURL=injectSheet.js.map